// This feature flag loadeer should be run once on app initilisation
// It will attempt to load the feature flage from the configured config cat envinroment
// And will save them into the redux store

import { useEffect } from 'react';
import { useConfigCatClient } from 'configcat-react';
import { useDispatch, useSelector } from 'react-redux';
import { appInsights } from '../Logging/appInsights';
import {
    featureFlagActions,
    Flag,
    FlagSource,
} from '../store/featureFlags';
import { IApplicationState } from '../store';


const FeatureFlagLoader = () => {
    const client = useConfigCatClient();
    const dispatch = useDispatch();

    const flagsHaveLoaded = useSelector((state: IApplicationState) => state.featureFlags.hasLoaded);
    const lastLoadedVenue = useSelector((state: IApplicationState) => state.featureFlags.lastLoadedVenueId);
    const userSessionId = useSelector((state: IApplicationState) => state.featureFlags.userSessionId);
    const selectedSite = useSelector((state: IApplicationState) => state.sites.selectedSite);

    useEffect(() => {

        //console.log(`feature flag loader use effect`);


        //if we don't have a user object, we can't load any meaningful configs
        if (userSessionId === undefined || userSessionId === '') {
            return;
        }

        // 'user' object sent to config cat for flag selection logic (eg venue dependant flags)
        const code = selectedSite?.code ?? "GLOBAL";
        const user = {
            identifier: userSessionId as string,
            custom: { venueCode: code },
        };


        // Loads every boolean setting in the ConfigCat config, not only KnownFlag keys,
        // so a Contentful booking alert can be gated by a new ConfigCat flag without a code change.
        // ConfigCat evaluates flags locally from its cached config, so reloading all of them on venue change costs no extra request.
        const loadFlags = async () => {

            dispatch(featureFlagActions.setLoading(true));

            let results: [string, boolean][] = [];
            try {
                const values = await client.getAllValuesAsync(user);
                results = values
                    .filter((x) => typeof x.settingValue === 'boolean')
                    .map((x) => [x.settingKey, x.settingValue as boolean]);
            } catch (error) {
                console.log(`ERROR loading configs from config cat, using defaults`);
                appInsights?.trackException(
                    { error: new Error(`Error loading configCat`), severityLevel: 3 },
                    {
                        url: window.location.href,
                        componentType: 'FeatureFlagLoader',
                        error: error,
                    }
                );
            }

            //build the list of recieved flags, to inject into the store
            const flags: Record<string, Flag> = {};
            for (const [key, value] of results) {
                console.log(`fetched config flag as [key:${key}, value:${value}] against ${code}`);
                flags[key] = {
                    enabled: value, venueId: selectedSite?.siteId ?? undefined, source: FlagSource.Fresh
                };
            }

            dispatch(featureFlagActions.setFlags(flags, selectedSite?.siteId ?? undefined));
            dispatch(featureFlagActions.setLoading(false));

            if (results.length > 0) {
                dispatch(featureFlagActions.setHasLoaded(true));
            } else {
                dispatch(featureFlagActions.setAbandoned(true));
            }
        };

        // load flags on first run, and again when the selected venue changes
        if (!flagsHaveLoaded || (selectedSite && lastLoadedVenue !== selectedSite.siteId)) {
            loadFlags();
        }

    }, [client, selectedSite, dispatch, flagsHaveLoaded, lastLoadedVenue, userSessionId]);


    // nothing to render
    return null;
};

export default FeatureFlagLoader;
